module.exports = __webpack_public_path__ + "img/max.05ee361.png";